export const TREE_COUNTER_URL =
  "https://storage.googleapis.com/setmorewebsite_language_bucket/admin/standard/assets/v2/common/tree-counter.json";
